<template>
    <div>
        <table-list
            idKey="blackId"
            :searchConfig="searchConfig"
            :listConfig="listConfig"
            :apis="apis"
            :btn-config="btnConfig" 
            :btnConfig="btnConfig | filterBtnsRole($route)"
        />
    </div>
</template>

<script>
import config from './config/Black.config'

export default {
    data() {
        return {
            ...config()
        }
    }
}
</script>

<style lang="less" scoped>

</style>
